export const getVoucherFrag = `
    issueDate
    validTo
    closureDate
    doctorId
    folderId
`;

export const copyVoucherFrag = `
    id
`;
